import { Typography } from "@mui/material";
import { FormBuilder } from "components/FormBuilder/FormBuilder";
import StrongPasswordPopper from "components/StrongPasswordPopper/StrongPasswordPopper";
import React, { useState } from 'react'
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { formPreventEnterSubmit } from "utils/utils";

/**
 * @param {object} props 
 * @param {import("react-hook-form").UseFormReturn} props.formProps
 * @param {boolean} props.disabled
 * @returns 
 */
const OnlineMerchantManagementEmployeeChangePasswordDialog = ({
  formProps,
  disabled
}) => {
  const { t: tCommon } = useTranslation();

  const [popperOpen, setPopperOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const isDisabled = disabled;
  const password = useWatch({ control: formProps.control, name: "password" });

  /** @type {Record<string, import("components/FormBuilder/lib/FormBuilderFieldBuilder").formBuilderFieldConfig>} */
  const fieldsConfig = {
    password: {
      fieldType: "textInput",
      fieldName: "password",
      label: tCommon("page.dialogs.changePassword.newPassword.label"),
      mandatory: true,
      disabled: isDisabled,
      config: {
        inputType: "password",
        rules: ["validStrongPassword"],
        customOnFocusFn: (e) => {
          setPopperOpen(true);
          setAnchorEl(e.target);
        },
        customOnBlurFn: () => {
          setPopperOpen(false);
          setAnchorEl(null);
        }
      }
    }
  }

  return (
    <form noValidate onKeyDown={formPreventEnterSubmit}>
      <FormBuilder.Row itemsPerRow={1}>
        {
          FormBuilder.buildFields({
            formProps,
            t: tCommon,
            fields: [
              fieldsConfig.password,
            ]
          })
        }
      </FormBuilder.Row>
      <Typography variant="content">
        {tCommon("page.dialogs.changePassword.newPassword.requirement.unique")}
      </Typography>
      <StrongPasswordPopper
        open={popperOpen}
        anchorEl={anchorEl}
        password={password}
      />
    </form>
  )
}

export default OnlineMerchantManagementEmployeeChangePasswordDialog